import {React, useState, useEffect} from 'react';
import { PlusIcon } from '@heroicons/react/solid';
import Divider from './individual/Divider';
import Spacer from './individual/Spacer';
import Title from './individual/Title';
import EditableTableToggle from './individual/EditableTableToggle';
import EditableTable from './individual/EditableTable';
import { apiCall } from '../services/api';

export default function Catalogus() {
    const [products, setProducts] = useState([])
    const [productSuppl, setProductsSuppl] = useState([])
    const [effect, setEffect] = useState(0);

    // Modal states
    const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);
    const [isAddSupplementModalOpen, setIsAddSupplementModalOpen] = useState(false);

    // Form fields for adding products
    const [newProductName, setNewProductName] = useState("");
    const [newProductLabel, setNewProductLabel] = useState("");

    // Form fields for adding supplements
    const [newSupplementName, setNewSupplementName] = useState("");

    useEffect(() => {
        const getProducts = async() => {
            const res = await apiCall('/catalogue/list/products/')
            const data = await res.json()
            setProducts(data)
        }
        const getProductsSuppl = async() => {
          const res = await apiCall('/catalogue/list/supplements/')
          const data = await res.json()
          setProductsSuppl(data)
        }
        getProducts();
        getProductsSuppl();
    }, [effect])

    // Toggle display on/off for products
    const toggleOff = async(id) => {
      const res = await apiCall('/catalogue/list/hide/' + id + '/', { method: 'POST' });
      const data = await res.json();
      if (data == "OK") {
        setEffect(effect + 1)
      } else {
        alert("Er is een onverwachte serverfout opgetreden.")
      }
    }

    const toggleOn = async(id) => {
      const res = await apiCall('/catalogue/list/show/' + id + '/', { method: 'POST' });
      const data = await res.json();
      if (data == "OK") {
        setEffect(effect + 1)
      } else {
        alert("Er is een onverwachte serverfout opgetreden.")
      }
    }

    // Add new product
    const addProduct = async() => {
      if (!newProductName || !newProductLabel) {
        alert("Vul alle velden in.");
        return;
      }
      const res = await apiCall('/catalogue/product/add/', {
        method: 'POST',
        body: JSON.stringify({ naam: newProductName.trim(), etiket: newProductLabel.trim() })
      });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else if (data.id) {
        setIsAddProductModalOpen(false);
        setNewProductName("");
        setNewProductLabel("");
        setEffect(effect + 1);
      } else {
        alert("Er is een fout opgetreden bij het toevoegen.");
      }
    }

    // Update existing product
    const updateProduct = async(id, naam, etiket) => {
      if (!naam || !etiket) {
        alert("Vul alle velden in.");
        return;
      }
      const res = await apiCall(`/catalogue/product/update/${id}/`, {
        method: 'POST',
        body: JSON.stringify({ naam: naam.trim(), etiket: etiket.trim() })
      });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else {
        setEffect(effect + 1);
      }
    }

    // Delete product
    const deleteProduct = async(id) => {
      const res = await apiCall(`/catalogue/product/delete/${id}/`, { method: 'DELETE' });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else {
        setEffect(effect + 1);
      }
    }

    // Add new supplement
    const addSupplement = async() => {
      if (!newSupplementName) {
        alert("Vul het naamveld in.");
        return;
      }
      const res = await apiCall('/catalogue/supplement/add/', {
        method: 'POST',
        body: JSON.stringify({ naam: newSupplementName.trim() })
      });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else if (data.id) {
        setIsAddSupplementModalOpen(false);
        setNewSupplementName("");
        setEffect(effect + 1);
      } else {
        alert("Er is een fout opgetreden bij het toevoegen.");
      }
    }

    // Update existing supplement
    const updateSupplement = async(id, naam) => {
      if (!naam) {
        alert("Vul het naamveld in.");
        return;
      }
      const res = await apiCall(`/catalogue/supplement/update/${id}/`, {
        method: 'POST',
        body: JSON.stringify({ naam: naam.trim() })
      });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else {
        setEffect(effect + 1);
      }
    }

    // Delete supplement
    const deleteSupplement = async(id) => {
      const res = await apiCall(`/catalogue/supplement/delete/${id}/`, { method: 'DELETE' });
      const data = await res.json();
      if (res.status === 400) {
        alert(data.error);
      } else {
        setEffect(effect + 1);
      }
    }

  return (
    <div className="mx-24">
      <Spacer height={50} />

      {/* Products section */}
      <div className="flex justify-between items-center">
        <Title text="Catalogus (assortiment)" type="head" />
        <button
          onClick={() => setIsAddProductModalOpen(true)}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
          Product toevoegen
        </button>
      </div>
      <Spacer height={15} />
      <Divider />
      <Spacer height={50} />
      <EditableTableToggle
        data={products}
        fields={['naam', 'etiket']}
        toggleOff={toggleOff}
        toggleOn={toggleOn}
        onUpdate={updateProduct}
        onDelete={deleteProduct}
      />

      <Spacer height={50} />

      {/* Supplementary products section */}
      <div className="flex justify-between items-center">
        <Title text="Catalogus (produits supplémentaire)" type="head" />
        <button
          onClick={() => setIsAddSupplementModalOpen(true)}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
          Supplémentair product toevoegen
        </button>
      </div>
      <Spacer height={15} />
      <Divider />
      <Spacer height={50} />
      <EditableTable
        data={productSuppl}
        fields={['naam']}
        onUpdate={updateSupplement}
        onDelete={deleteSupplement}
      />
      <Spacer height={50} />

      {/* Add Product Modal */}
      {isAddProductModalOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setIsAddProductModalOpen(false)}></div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                      Product toevoegen
                    </h3>
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-700">
                        Naam
                      </label>
                      <input
                        type="text"
                        value={newProductName}
                        onChange={(e) => setNewProductName(e.target.value)}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        placeholder="Naam van het product"
                      />
                    </div>
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-700">
                        Etiket
                      </label>
                      <input
                        type="text"
                        value={newProductLabel}
                        onChange={(e) => setNewProductLabel(e.target.value)}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        placeholder="Etiket van het product"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={addProduct}
                >
                  Opslaan
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setIsAddProductModalOpen(false)}
                >
                  Annuleren
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Supplement Modal */}
      {isAddSupplementModalOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setIsAddSupplementModalOpen(false)}></div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                      Supplémentair product toevoegen
                    </h3>
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-700">
                        Naam
                      </label>
                      <input
                        type="text"
                        value={newSupplementName}
                        onChange={(e) => setNewSupplementName(e.target.value)}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        placeholder="Naam van het supplémentair product"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={addSupplement}
                >
                  Opslaan
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setIsAddSupplementModalOpen(false)}
                >
                  Annuleren
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
